import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";

export const module: Module = {
  id: ResourceEnum.StockMove,
  name: (t: TFunction) => t("moduleName.inventory-move"),
  bigIcon: <i className={"icon-20-mov_gds"} />,
  smallIcon: <i className={"icon-15-mov_gds"} />,
  disableEdit: true,
  disableDelete: true,
};
